import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import copyTextToClipboard from '../../../../utils/copy_text';
import Modal from '../../../shared/modal';

/**
 * @prop {any} url
 */

class ShareButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCopied: false,
      isClicked: false,
    };
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.showCopied = this.showCopied.bind(this);
    this.copiedTimer = null;
  }

  copyToClipboard() {
    copyTextToClipboard(this.props.url, this.showCopied, this.showModal);
  }

  showCopied() {
    this.setState(
      {
        isCopied: true,
        isClicked: true,
      },
      this.resetShareButton,
    );
  }

  showModal() {
    this.setState({
      isCopied: false,
      isClicked: true,
    });
  }

  closeModal() {
    this.setState({
      isCopied: false,
      isClicked: false,
    });
  }

  resetShareButton() {
    window.clearTimeout(this.copiedTimer);
    this.copiedTimer = window.setTimeout(() => {
      this.setState({
        isCopied: false,
        isClicked: false,
      });
    }, 750);
  }

  render() {
    const { isCopied, isClicked } = this.state;
    const styleName = classNames('IndexAction-button', {
      'IndexAction-button--square': !isCopied,
      'IndexAction-button--success': isCopied,
    });
    return (
      <>
        <button
          type="button"
          className={styleName}
          onClick={!isCopied ? this.copyToClipboard : null}
        >
          {!isCopied && (
            <Icon name="link" title={t('content.share_button.copy_link')} />
          )}
          {isCopied && <span>{t('content.share_button.copied')}</span>}
        </button>
        <Modal
          show={!isCopied && isClicked}
          title={t('content.share_button.copy_link')}
          dismissCallback={this.closeModal}
        >
          {t('content.share_button.share_text')}
          <input
            ref={node => {
              if (node) node.select();
            }}
            type="text"
            value={this.props.url}
            readOnly
            onClick={e => e.target.select()}
          />
        </Modal>
      </>
    );
  }
}

export default ShareButton;
